import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppService } from '../../service/app.service';


@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.page.html',
  styleUrls: ['./set-password.page.scss'],
})
export class SetPasswordPage implements OnInit {

  keyboard: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, '', 'delete'];
  viewPassword: boolean = false;
  activeAmount: any = [
    { value: null, active: false },
    { value: null, active: false },
    { value: null, active: false },
    { value: null, active: false },
    { value: null, active: false },
    { value: null, active: false },
  ];
  userAmount: any = '';


  constructor(public modalController: ModalController,
    public appService: AppService) { }

  async ngOnInit() {
    let localpassword = await this.appService.checkLocalPassword();
    if (localpassword) {
      this.userAmount = '123456';
      this.activeAmount = localpassword;
    }
  }


  /**
   * @method { method will close the modal }
   */
  closeModal() {
    this.modalController.dismiss();
  }


  /**
* @method { Method will concat the user entering amount }
* @memberof HomePage
* @author fayiz
*/
  addAmount(key) {
    if (key === 'delete') {
      this.removeKey();
    }
    if (key !== '' && key !== 'delete') {
      this.pushAmount(key);
    }

  }

  pushAmount(key) {
    if (this.userAmount.length < 6) {
      this.userAmount += key;
      this.activeAmount[this.userAmount.length - 1].active = true;
      this.activeAmount[this.userAmount.length - 1].value = key;
    }
  }


  removeKey() {
    this.userAmount = this.userAmount.slice(0, -1);
    this.activeAmount[this.userAmount.length].active = false;
    this.activeAmount[this.userAmount.length].value = null;
  }


  passwordVisible() {
    this.viewPassword = this.viewPassword ? false : true;
  }

  setPassword() {
    for (let i = 0; i < this.activeAmount.length; i++) {
      if (!this.activeAmount[i].value) {
        break;
      }
      if (i == 5) {
        localStorage.setItem('password', JSON.stringify(this.activeAmount));
        localStorage.setItem('password_auth_key', localStorage.getItem('auth_key'));
        this.modalController.dismiss();
        this.appService.toastMessage('Password set successfully');
      }
    }
    if (this.userAmount.length < 6) {
      this.appService.toastMessage('Please set 6 digit password');
    }
  }
}
